import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../components/Sidebar";
import Header from "../components/Header";
import { Scrollbars } from "rc-scrollbars";

const MainLayout = () => {
  return (
    <Fragment>
      <div className="bg-dark-green d-flex position-relative">
        <SideBar />
        <div className="p-md-3 p-0 w-100 min-vh-100">
          <Header />
          <Scrollbars
            autoHide={false}
            autoHeight
            autoHeightMax="calc(100vh - 112px)"
            renderThumbVertical={({ style, ...props }) => (
              <div
                {...props}
                style={{
                  ...style,
                  backgroundColor: "#AAA", // Change color
                  borderRadius: "4px",
                }}
              />
            )}
          >
            <div className="main-container bg-light h-100 px-xl-5 px-3 py-xl-4 py-3">
              <Outlet />
            </div>
          </Scrollbars>
        </div>
      </div>
    </Fragment>
  );
};

export default MainLayout;
